import { createApi } from "@reduxjs/toolkit/query/react";

import { type IApiResponse } from "@/shared/interfaces/api-response.interface";

import customFetchBase from "../custom-fetch-base";

export interface ISubmitSupportRequest {
  subject: string;
  body: string;
  imageUrl?: string;
  districtId?: string;
}

const supportApi = createApi({
  reducerPath: "supportApi",
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    submitSupportRequest: builder.mutation<{ message: string }, ISubmitSupportRequest>({
      query: (data) => ({
        url: "/support",
        method: "POST",
        body: data,
      }),
      transformResponse: (result: IApiResponse<{ message: string }>) => {
        return result.data;
      },
    }),
  }),
});

export const { useSubmitSupportRequestMutation } = supportApi;

export default supportApi;
